module.exports = __webpack_public_path__ + "img/chainlink.43e916c6.png";